import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { CSSProperties, FC, useContext } from "react";

import {
  StationRouteContext,
  StationRouteStationContext,
  useStationRouteStationCtxProvider,
} from "@ryde/redux";
import {
  canReorderRoutingWaypoint,
  DragTypeStationEnum,
  isStationRouteRouteStructureLocked,
  isStationRouteWaypointStation,
  IStationRouteProps,
  TDragDropStationRouteSortable,
} from "@ryde/shared";

import { StationRowStationRoute } from "./station-route.row";
import { StationRouteStationStyled } from "./station-route.station.styled";

export const StationRouteStation: FC<IStationRouteProps> = props => {
  const {
    station,
    stationRouteDto,
    isDragClone,
    isDragReorderAllowed = true,
  } = props;
  const { rideOpenerId } = useContext(StationRouteContext);

  const stationRouteStationData = useStationRouteStationCtxProvider(props);
  const isWaypoint = isStationRouteWaypointStation(station);
  const isWaypointReorderable = canReorderRoutingWaypoint(
    stationRouteDto?.computedData?.stationInfos,
  );
  const isSortableEnabled =
    isDragReorderAllowed &&
    !isStationRouteRouteStructureLocked(rideOpenerId) &&
    (!isWaypoint || isWaypointReorderable);

  const dragData: Omit<TDragDropStationRouteSortable, "sortable"> = {
    type: DragTypeStationEnum.STATION,
    payload: props,
  };

  const {
    attributes,
    listeners,
    setNodeRef,
    isDragging,
    transform,
    transition,
  } = useSortable({
    id: station.id,
    data: dragData,
    disabled: !isSortableEnabled,
  });

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
  };
  return (
    <StationRouteStationContext.Provider
      value={{
        ...props,
        ...stationRouteStationData,
        stationRouteDto,
        isDragging,
        listeners,
        attributes,
        isDragReorderAllowed,
      }}
    >
      <StationRouteStationStyled
        $isDragging={isDragging}
        $isDragClone={isDragClone}
        $isWaypoint={Boolean(station.waypointCategory)}
        style={style}
        data-e2e-id={station.id}
        ref={!station?.isLocked && isSortableEnabled ? setNodeRef : null}
      >
        <StationRowStationRoute />
      </StationRouteStationStyled>
    </StationRouteStationContext.Provider>
  );
};
